export { default as ProductOrderingListTemplate } from './ProductOrderingListTemplate';
export { default as ProductOrderingEditTemplate } from './ProductOrderingEditTemplate'; 